/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { authUserOutputDataOrganisationHeadcountSchema } from './AuthUserOutputDataOrganisationHeadcountSchema'
import { authUserOutputDataRecruitingVolumeSchema } from './AuthUserOutputDataRecruitingVolumeSchema'

export const authUserOutputDataSchema = z.object({
	id: z.string(),
	email: z.string(),
	firstName: z.string().nullable(),
	lastName: z.string().nullable(),
	profilePictureUrl: z.string().nullable(),
	language: z.string().default('en-GB'),
	firstLoginAt: z.iso.datetime().nullable(),
	onboardingCompletedAt: z.iso.datetime().nullable(),
	recruitingVolume: authUserOutputDataRecruitingVolumeSchema.nullable(),
	contactsCandidates: z.boolean().nullable(),
	managesTeam: z.boolean().nullable(),
	organisationHeadcount: authUserOutputDataOrganisationHeadcountSchema.nullable(),
	phoneNumber: z.string().nullable(),
	isSelfSignup: z.boolean().default(false),
	isProvisioned: z.boolean().default(true),
})

export type AuthUserOutputDataSchema = z.infer<typeof authUserOutputDataSchema>
